export default (obj: any) => JSON.parse(JSON.stringify(obj), omitTypename)

const omitTypename = (key: string, value: string) => (key === '__typename' ? undefined : value)
